import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
// import { TranslateModule } from '@ngx-translate/core';
import { DaButtonModule } from '../da-button/da-button.module';
import { DaLinkModule } from '../da-link/da-link.module';
import { DaProgressiveImageModule } from '../da-progressive-image/da-progressive-image.module';
import { SearchItemComponent } from './search-item.component';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [{ path: '', component: SearchItemComponent }];

@NgModule({
    declarations: [SearchItemComponent],
    exports: [SearchItemComponent],
    imports: [CommonModule, TranslateModule, RouterModule, LocalizeRouterModule, DaButtonModule, DaLinkModule, DaProgressiveImageModule]
})
export class SearchItemModule {}
